(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swiftpod-video-behavior"] && !Shopify.designMode) return;
  try {
    (() => {
    const boot = () => {
      const config = document.querySelector('[data-swiftpod-video-behavior]');
      if (!config || config.dataset.ready) return;
      config.dataset.ready = 'true';
      const states = new Map();
      const sync = (state) => {
        const { video, host } = state;
        if (!state.visible || document.hidden || !video.isConnected) {
          video.pause();
          return;
        }
        video.muted = true;
        if (video.dataset.src) {
          video.src = video.dataset.src;
          delete video.dataset.src;
        }
        if (!video.paused || state.pending) return;
        state.pending = true;
        video.play().then(() => {
          if (host.matches('video-media')) {
            host.setAttribute('loaded', '');
            host.setAttribute('can-play', '');
          }
          if (!state.visible || document.hidden) video.pause();
        }).catch(() => {}).finally(() => { state.pending = false; });
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const state = states.get(entry.target);
          if (!state) return;
          state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
          sync(state);
        });
      }, { threshold: [0, 0.1] });
      const scan = () => {
        states.forEach((state, video) => {
          if (video.isConnected) return;
          observer.unobserve(video);
          video.pause();
          states.delete(video);
        });
        document.querySelectorAll('#main video-media:not([host]) > video, #main .sp-video-guide__video').forEach((video) => {
          if (states.has(video)) return;
          const host = video.parentElement;
          host.classList.add('sp-loop-media');
          host.removeAttribute('group');
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.playsInline = true;
          video.controls = false;
          video.disablePictureInPicture = true;
          video.disableRemotePlayback = true;
          video.setAttribute('tabindex', '-1');
          host.removeAttribute('show-play-button');
          const state = { video, host, visible: false, pending: false };
          states.set(video, state);
          video.addEventListener('play', () => {
            if (!state.visible || document.hidden) video.pause();
            else if (host.matches('video-media')) host.setAttribute('loaded', '');
          });
          observer.observe(video);
        });
      };
      scan();
      new MutationObserver(scan).observe(document.getElementById('main'), { childList: true, subtree: true });
      document.addEventListener('visibilitychange', () => states.forEach(sync));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
